import * as type from './types';
import { forecastingBaseApiUrl, getAccessToken } from '../utils/apiHelpers';
import { getVenueId, hasForecastBypass } from '../utils/helpers';

const getHeaders = async () => {
  const token = await getAccessToken();
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');
  if (token) {
    myHeaders.append('Authorization', `Bearer ${token}`);
  }
  return myHeaders;
};

const fetchForecasterEnabledApi = async (venueId) => {
  const headers = await getHeaders();
  const response = await fetch(`${forecastingBaseApiUrl}/api/venue/venues/${venueId}/enabled`, {
    method: 'GET',
    headers,
  });

  return response;
};

const fetchForecastStatusApi = async (venueId) => {
  const headers = await getHeaders();
  const response = await fetch(
    `${forecastingBaseApiUrl}/api/venue/venues/${venueId}/forecast-status`,
    {
      method: 'GET',
      headers,
    },
  );

  return response;
};

export const fetchForecasterEnabledAction = (restaurant) => async (dispatch) => {
  dispatch({ type: type.FETCH_FORECASTER_ENABLED_PENDING });
  try {
    const venueId = getVenueId(restaurant);

    // Condition 0: PRODTEST is always enabled
    if (hasForecastBypass(restaurant)) {
      dispatch({ type: type.FETCH_ANALYTICS_ENABLED_SUCCESS, payload: true });
      dispatch({ type: type.FETCH_FORECASTER_ENABLED_SUCCESS, payload: true });
      return;
    }

    // Condition 1: Venue must not be paused
    // Moved out of here for separation of concerns. It's up to the logic in the usage to determine if the venue being paused is relevant.

    // Condition 2: /enabled API must return 200 with { forecast_enabled, analytics_enabled }
    const enabledResponse = await fetchForecasterEnabledApi(venueId);
    if (enabledResponse.status !== 200) {
      dispatch({ type: type.FETCH_ANALYTICS_ENABLED_SUCCESS, payload: false });
      dispatch({ type: type.FETCH_FORECASTER_ENABLED_SUCCESS, payload: false });
      return;
    }

    const enabledData = await enabledResponse.json().catch(() => ({}));
    const forecastEnabledFromBody = enabledData?.forecast_enabled === true;
    const analyticsEnabledFromBody = enabledData?.analytics_enabled === true;
    dispatch({ type: type.FETCH_ANALYTICS_ENABLED_SUCCESS, payload: analyticsEnabledFromBody });

    // If forecast is disabled from body, skip forecast-status check
    if (!forecastEnabledFromBody) {
      dispatch({ type: type.FETCH_FORECASTER_ENABLED_SUCCESS, payload: false });
      return;
    }

    // Condition 3: /forecast-status API must return success with isEnabled === true
    const forecastStatusResponse = await fetchForecastStatusApi(venueId);
    if (forecastStatusResponse.status === 200) {
      const data = await forecastStatusResponse.json().catch(() => ({}));
      const isEnabled = data?.isEnabled === true;
      dispatch({ type: type.FETCH_FORECASTER_ENABLED_SUCCESS, payload: isEnabled });
    } else {
      dispatch({ type: type.FETCH_FORECASTER_ENABLED_SUCCESS, payload: false });
    }
  } catch (error) {
    dispatch({ type: type.FETCH_FORECASTER_ENABLED_FAILURE, payload: error?.message });
  }
};
